<template>
  <div v-if="agreement" class="modal" :class="{active: show}">
    <a class="modal-overlay" @click="close"></a>
    <div class="modal-container">

      <div class="modal-header">
        <a @click="close" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">Send cost agreement</div>
      </div>


      <div class="modal-body">
        <div class="content">

          <div class="form-group">
            <label class="form-label" for="input-example-3">Message</label>
            <quillEditor id="editor" v-model="message" :options="editorOptions" />
          </div>

          <div class="form-group">
            <label class="form-label">Add a Factsheet</label>
            <select v-model="attachments" class="form-select" multiple>
              <option v-for="(f, index) in files" :value="index">{{f.listname}}</option>
            </select>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" @click.prevent="send" :class="{loading: sending}">Send</button>
        <span v-if="sendError" class="label label-error">Something went wrong</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'sendAgreementModal',
  props: ['show', 'agreement', 'invoice'],
  components: { quillEditor },
  data () {
    return {
      sending: false,
      sendError: false,
      message: '',
      attachments: [], // indices of the file list
      editorOptions: {
        theme: 'bubble'
      },
      files: [{
        listname: 'Sponsorship Obligations',     // name in the selection box
        filename: 'Sponsorship Obligations', // name in the email
        path: '482/sponsorship-obligations.pdf'  // actual path to file
      }, {
        listname: 'TSS Visa Fact Sheet',
        filename: 'TSS Visa Fact Sheet',
        path: '482/TSS-Visa-Fact-Sheet.pdf'
      }]
    }
  },
  watch: {
    agreement () {
      this.updateMessage()
    }
  },
  methods: {
    updateMessage () {
      let a = this.agreement
      if (!a) return
      let name = a.name.split(' ')[0]
      let brand = null

      if (a.brand && a.brand === 'ie') {
        brand = 'Immigration Experts'
      } else {
        brand = 'PocketLegal'
      }

      if (this.invoice) {
        let link = [window.location.origin, '/#/invoices/', this.invoice._id].join('')
        this.message = [
          '<p>Hi ', name, ',</p>',
          '<p>We have prepared a Costs Agreement for you, which you will find attached to this email.</p>',
          '<p>To have us commence work on your matter right away, please make the payment contained in the attached invoice.</p>',
          '<p>If preferred, you can <a href=\'', link, '\' target=\'_blank\'>click here to pay online</a></p>',
          '<p>Regards,<br>', brand, '</p>'].join('')
      } else {
        this.message = [
          '<p>Hi ', name, ',</p>',
          '<p>We have prepared and attached a costs agreement for you.</p>',
          '<p>Regards,<br>', brand, '</p>'].join('')
      }
    },
    close () {
      this.$emit('close')
    },
    send () {
      this.sending = true
      this.sendError = false
      axios.post('/api/agreements/send', {
        agreementId: this.agreement._id,
        message: this.message,
        sendInvoice: this.invoice !== null,
        files: this.attachments.map(i => { return this.files[i] })
      })
      .then(res => {
        if (res.status === 200) {
          this.sending = false
          this.agreement.sent = true
          this.close()
        }
      })
      .catch(e => {
        this.sending = false
        this.sendError = true
        console.log(e.response.data)
      })
    }
  }
}
</script>

<style scoped>
#editor {
  border: .05rem solid #caced7;
  border-radius: .1rem;
}
select.form-select option {
  position: relative;
  padding: .1rem .2rem .1rem 25px;
}
select.form-select option:before {
  content: "";
  border: 1px solid #116cd6;
  height: 12px;
  width: 12px;
  background: #fff;
  border-radius: 2px;
  position: absolute;
  left: 4px;
  top: 6px;
}
select.form-select option:checked:after {
  content: "L";
  position: absolute;
  color: #116cd6;
  left: 8px;
  top: 4px;
  -ms-transform: scaleX(-1) rotate(-35deg);
  -webkit-transform: scaleX(-1) rotate(-35deg);
  transform: scaleX(-1) rotate(-35deg);
  font-size: 11px;
  font-weight: bold;
}
.modal-footer .btn {
  background: #136efb!important;
  border-color: #136efb!important;
  color: #fff
}
.modal-footer .btn.loading::after {
  border-bottom-color: #fff;
  border-left-color: #fff;
}
</style>



// WEBPACK FOOTER //
// sendAgreementModal.vue?0f5167cf